import { h, render } from "preact";
import { AppConfig } from "./ts/types";

import parseAppConfigHTMLAttribute from "@common/helpers/parseAppConfigHTMLAttribute";
import getSearchClient from "./core/getSearchClient";
import getResultsFormatter from "./core/resultsFormatter";
import Main from "./components/Main";

export default (appDOMNode, searchInputDOMNode) => {
  const appConfig: AppConfig = parseAppConfigHTMLAttribute(appDOMNode);

  const searchClient = getSearchClient(
    window.dynamic_faq.search_widget_configuration.algolia
  );

  const formatResults = getResultsFormatter(
    window.dynamic_faq.search_widget_configuration.view_question_route
  );

  const algoliaSearchFilters =
    window.dynamic_faq.search_widget_configuration.algolia.mandatory_filters;

  const renderedApp = render(
    <Main
      algoliaSearchFilters={algoliaSearchFilters}
      appConfig={appConfig}
      searchClient={searchClient}
      formatResults={formatResults}
      searchInputDOMNode={searchInputDOMNode}
    />,
    appDOMNode
  );

  return function disposeCallback() {
    render("", appDOMNode, renderedApp);
  };
};
